module.exports = __webpack_public_path__ + "img/spa_preview_search.f5238e4b.png";